import React from 'react';
import { Stack, Select, MenuItem, SelectChangeEvent, FormControl } from '@mui/material';
import { TimeRangeFilter } from '../Policy/_types';
import { TIME_RANGE_OPTIONS } from '../Policy/_constants';
import { useRiskPoolOrgContext } from '../RiskPoolOrgContext';

interface FiltersProps {
  allOrganizations?: Array<{ id: string; name: string }>;
  onOrgChange: (event: SelectChangeEvent<string>) => void;
}

export default function Filters({ allOrganizations, onOrgChange }: FiltersProps) {
  const { orgId, timeRangeFilter, setTimeRangeFilter } = useRiskPoolOrgContext();

  const handleTimeRangeChange = (event: SelectChangeEvent<string>) => {
    const newRange = event.target.value as TimeRangeFilter;
    setTimeRangeFilter(newRange);
  };

  return (
    <Stack
      direction='row'
      spacing={2}
      alignItems='center'
    >
      {/* Organization Dropdown */}
      {allOrganizations && allOrganizations.length > 0 && (
        <FormControl
          size='small'
          sx={{ p: 0 }}
        >
          <Select
            value={orgId}
            onChange={onOrgChange}
            displayEmpty
            sx={{
              minWidth: 200,
              backgroundColor: 'white',
              '& .MuiSelect-select': {
                py: 1,
              },
            }}
          >
            {allOrganizations.map((org) => (
              <MenuItem
                key={org.id}
                value={org.id}
              >
                {org.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Time Range Dropdown */}
      <FormControl
        size='small'
        sx={{ p: 0 }}
      >
        <Select
          value={timeRangeFilter}
          onChange={handleTimeRangeChange}
          displayEmpty
          sx={{
            minWidth: 180,
            backgroundColor: 'white',
            '& .MuiSelect-select': {
              py: 1,
            },
          }}
        >
          {TIME_RANGE_OPTIONS.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
